import { render, staticRenderFns } from "./cashierReceipt.vue?vue&type=template&id=2646bc1a"
import script from "./cashierReceipt.vue?vue&type=script&lang=js"
export * from "./cashierReceipt.vue?vue&type=script&lang=js"
import style0 from "./cashierReceipt.vue?vue&type=style&index=0&id=2646bc1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports